import React from 'react';
import { Accordion } from './Accordion';
import { SettingsIcon, MailIcon } from 'lucide-react';
import { OBJECTIONS } from '../lib/content';
export function ObjectionsSupport() {
  return <div data-id="element-123">
      <h3 className="mb-4 text-center font-display text-xl uppercase text-white" data-id="element-124">
        Frequently Asked Questions
      </h3>
      <div className="space-y-2.5" data-id="element-125">
        {OBJECTIONS.map((o, i) => <Accordion key={i} emoji="❓" title={o.q} body={o.a} data-id="element-126" />)}
      </div>

      {/* Support */}
      <div className="mt-8 flex flex-col items-center gap-3 text-center" data-id="element-127">
        <div className="flex h-14 w-14 items-center justify-center rounded-full border border-orange-500/40 bg-neutral-900" data-id="element-128">
          <SettingsIcon className="h-7 w-7 text-orange-400" data-id="element-129" />
        </div>
        <p className="text-xs uppercase tracking-wider text-neutral-400" data-id="element-130">
          Support
        </p>
        <a href="mailto:EbookDreamShop@gmail.com" className="flex items-center gap-2 text-sm font-semibold text-orange-400 hover:text-orange-300" data-id="element-131">
          <MailIcon className="h-4 w-4" data-id="element-132" />
          EbookDreamShop@gmail.com
        </a>
      </div>
    </div>;
}